/* eslint semi:0 */
import { appDispatcher } from '../../application/AppDispatcher'
import { namespacedConsts } from '../../utils/object'

const ACTION_COUNTER_PROVIDER_CONSTS = namespacedConsts({
  ACTIONS: {
    DATA_RECEIVED: true,
    RECEIVED_ERROR: true,
  },
})

export const TYPES = ACTION_COUNTER_PROVIDER_CONSTS.ACTIONS

export const dataReceived = data => {
  appDispatcher.dispatchAction.external({
    type: TYPES.DATA_RECEIVED,
    data,
    fluxToRedux: true,
  })
}

export const receivedError = error => {
  appDispatcher.dispatchAction.external({
    type: TYPES.RECEIVED_ERROR,
    error,
    fluxToRedux: true,
  })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/actions/actionCounterProviderActions.js